import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { adminWorkspacesKeys } from 'app/queries/adminWorkspaces/adminWorkspacesKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminWorkspacesKeys.list>>;

export const createFetchWorkspacesQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        AdminService.getWorkspacesList({
          pageNo: params.page.toString(),
          pageSize: params.pageSize.toString(),
          orderBy: params.orderBy,
          orderType: params.orderType,
          search: params.search,
        }),
        signal,
      ),
    );
